import React from 'react'

export const ServiceIcon = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
<rect width="44" height="44" rx="22" fill="white" fill-opacity="0.39"/>
<g clip-path="url(#clip0_42_818)">
<path d="M15.9372 30.3273L27.532 14.0313M27.532 14.0313L14.9812 16.1468M27.532 14.0313L29.6476 26.5822" stroke="white" stroke-width="2"/>
</g>
<defs>
<clipPath id="clip0_42_818">
<rect width="24" height="24" fill="white" transform="translate(5 25) rotate(-54.5676)"/>
</clipPath>
</defs>
</svg>
  )
}
